/**
* 底部菜单
*/ 
<template>
  <!-- 底部2 -->
  <footer class="footer" id="footer2">
    <div class="footer_bar"></div>
    <div class="footer_menu clearfix">
      <div class="wrap1 clearfix">
        <div class="fl">
          <dl v-for="(item,index) in leftMenu" :key='index'>
            <dt>{{item.categoryName}}</dt>
            <dd v-for="(titleItem,indexs) in item.helpArticleList" :key="indexs">
              <li>
                <router-link :to="`siteHelpDetail?itemId=${titleItem.articleId}`"
                >
                  <div class="OneLineDisplay" :title="titleItem.articleTitle">{{titleItem.articleTitle}}</div></router-link>
              </li>            
            </dd>
          </dl>
          
        </div>
        <div class="fr" style="display: none">
          <!-- <div class="footer_logo">
            <img
              src="//xunyoutest.com/shop/static/src/default/images/index/footlogo.png"
            />
          </div>
          <div class="shop_code">
            <div class="footer_wx fr">
              <img
                src="//xunyoutest.com/shop/static/src/default/images/index/footwx.png"
              />
            </div>
            <div class="footer_wap fr">
              <img
                src="//xunyoutest.com/shop/static/src/default/images/index/footwap.png"
              />
            </div> -->
          <!-- </div> -->
        </div>
      </div>

      <div class="copyright_pc">
        <p>
          {{informations.copyrightInformation}} <br />
          <a :href="informations.icpUrl" target="_blank"
            >{{informations.icp}}</a
          >
        </p>
        <!--<p><a href="http://webscan.360.cn/index/checkwebsite/url/www.xunyoutest.com"><img border="0" src="http://webscan.360.cn/status/pai/hash/9c7d033758c4f753bc19ee404a1adb4c"/></a></p>-->
      </div>
    </div>
  </footer>
</template>
<script>
import { menu } from "../api/userMG";
import {helpArticle_list,article_category_list,copyRight,bottom_article_list} from '@/api/xunyou'
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: [],
      leftMenu:[],  
      informations:{}   
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
   //this.getHelpArticle_list()
   this.getArticleList()
   this.geTCopyright()
  },
  methods:{
    // 获取版权名称
    geTCopyright(){
      copyRight().then(res=>{
        console.log(res)
        if(res.code==0){
          this.informations = res.rows[0]
          if(this.informations.powstatus==1){
            this.$router.push('/erroPage')
          }else{
             this.$store.commit('getcopyRight',this.informations)
          }
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },
    // 文章分类列表   
        getArticleList(){
            bottom_article_list()
                .then(res => {
                if (res.code == 0) {
                    this.leftMenu = res.rows.slice(0,5);
                    
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('获取列表失败，请稍后再试！')
                })
        },
        // 文章（和公告）列表接口   
        getHelpArticle_list(){
            helpArticle_list()
                .then(res => {
                if (res.code == 0) {
                    this.allmenu =res.rows;
                    // if(res.rows.length>0){
                        
                    // const s = new Set() //实例化对象
                    // console.log(s,'封装数据------------')

                    // res.rows.forEach(item => s.add(item.categoryId)) //添加值（Set可以去掉重复数据）

                    // let newData = Array.from({ length: s.size }, () => []) //创建指定长度数组并添值

                    // res.rows.forEach(item => {

                    //     let index = [...s].indexOf(item.categoryId) //找到指定下标

                    //     newData[index].push(item) //添加数据

                    // })
                    // this.allmenu = newData
                    //   console.log(this.allmenu,'封装数据------------')
                    // }
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                // this.loading = false
                this.$message.error('获取文章列表失败，请稍后再试！')
                })
        },
  }
};
</script>
<style scoped lang='less'>
.footer_menu{
  position: relative;
}
.footer .footer_menu dl{
  width: 200px;
  margin:15px
}
.footer .footer_menu dl dt{
  text-align: left;
  
}
.footer .footer_menu dl dd{
     text-align: left;
  }
.copyright_pc{
  position: revert;
  text-align: center;
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/footernav.vue